import React from 'react';
import cn from 'classnames';

import PIC_BEAUTY_INACTIVE from '../../assets/images/beauty.svg';
import PIC_BEAUTY_ACTIVE from '../../assets/images/beauty-active.svg';
import PIC_HAIR_INACTIVE from '../../assets/images/blowdry.svg';
import PIC_HAIR_ACTIVE from '../../assets/images/blowdry-active.svg';
import PIC_OTHER_INCACTIVE from '../../assets/images/cutting.svg';
import PIC_OTHER_ACTIVE from '../../assets/images/cutting-active.svg';
import { USE_CUSTOM_SETUP } from '../../config/use.conf';

const SALON_TYPE_STYLE = Object.freeze({ opacity: 0.8 });
const IMAGE_STYLE = Object.freeze({ width: 52, marginTop: -34 });

const QuickSetupType = ({ active, onOptionClick }) => (
  <div data-bem="QuickSetupType" className="content auto-height">
    <label htmlFor="salonTypeSelector">
      <div style={SALON_TYPE_STYLE}>Select your salon type</div>

      <div id="salonTypeSelector">
        <div data-bem="QuickSetupType__option-1" className="row">
          <button
            className={cn({
              'section-button': true,
              'active-border': active === 1,
            })}
            onClick={() => void onOptionClick(1)}
          >
            <img
              className="section-icon"
              src={active === 1 ? PIC_HAIR_ACTIVE : PIC_HAIR_INACTIVE}
              alt="ServicePriceImage"
              style={IMAGE_STYLE}
            />
            <div className="section-text-wrap">
              <div className="section-header-text">Hair or Barbering</div>
              <div className="section-text">Our quick salon setup is perfect for salons who offer hair services</div>
            </div>
          </button>
        </div>
        <div data-bem="QuickSetupType__option-2" className="row">
          <button
            className={cn({
              'section-button': true,
              'active-border': active === 2,
            })}
            onClick={() => void onOptionClick(2)}
          >
            <img
              className="section-icon"
              src={active === 2 ? PIC_BEAUTY_ACTIVE : PIC_BEAUTY_INACTIVE}
              alt="ServicePriceImage"
              style={IMAGE_STYLE}
            />
            <div className="section-text-wrap">
              <div className="section-header-text">Beauty Salon</div>
              <div className="section-text">Our quick salon setup is perfect for salons who offer beauty services</div>
            </div>
          </button>
        </div>
        {USE_CUSTOM_SETUP && (
          <div data-bem="QuickSetupType__option-3" className="">
            <button
              className={cn({
                'section-button': true,
                'active-border': active === 3,
              })}
              onClick={() => void onOptionClick(3)}
            >
              <img
                className="section-icon"
                src={active === 3 ? PIC_OTHER_ACTIVE : PIC_OTHER_INCACTIVE}
                alt="RolePriceImage"
                style={IMAGE_STYLE}
              />
              <div className="section-text-wrap">
                <div className="section-header-text">Other</div>
                <div className="section-text">
                  More quick setups are coming soon! For now we suggest using customisable setup
                </div>
              </div>
            </button>
          </div>
        )}
      </div>
    </label>
  </div>
);

export default QuickSetupType;
